import React from 'react';
import { Snackbar, SnackbarContent } from '@mui/material';
import { AlertSnackbarSeverities } from '@/types';
import styles from './AlertSnackbar.module.scss';
import CloseButton from '../CloseButton/CloseButton';

const snackbarIcons = {
  Error: 'icon-blitz-fehler',
  Success: 'icon-check',
  Warning: 'icon-information',
  Info: 'icon-information',
  Fixed: 'icon-information',
};

type AlertSnackbarProps = {
  id: string;
  severity: AlertSnackbarSeverities;
  open: boolean;
  children: React.ReactNode;
  onClose: () => void;
  text?: string;
};

const AlertSnackbar: React.FC<AlertSnackbarProps> = (props) => {
  const { id, severity, open, children, onClose, text = '' } = props;
  const iconSeverity = snackbarIcons[severity] || snackbarIcons.Error;

  return (
    <Snackbar
      id={id}
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      className={styles.Snackbar}
    >
      <SnackbarContent
        classes={{ root: styles[severity] || styles.Error, message: styles.MessageSize }}
        data-testid={`${id}-snackbar-content`}
        message={(
          <div className={styles.Content}>
            <i className={`di ${iconSeverity} ${styles.Icon}`} />
            {children || text}
          </div>
        )}
        action={(
          <CloseButton onClick={onClose} closeStyle={styles.IconButton} />
        )}
      />
    </Snackbar>
  );
};

export default AlertSnackbar;
